import styled from 'styled-components';
import { Amenity } from './Amenity';
import { useEffect, useState } from 'react';
import MiniRoadView from './MiniRoadView';
import { useMapFilterContext } from '../../../context/MapFilterContext';
import MapService from '../../../service/map/Map';
import { isLogin } from '../../../utils/auth';
import { useModal } from '../../../context/ModalContext';
import MapSettingModal from '../../newMap/components/MapSettingModal';
import RegionModal from '../../newMap/components/regionModal/RegionModal';

const MapFilter = ({
  onTraffic,
  setOnTraffic,
  onSchool,
  setOnSchool,
  onPublicOffice,
  setOnPublicOffice,
  onHospital,
  setOnHospital,
  getUserLocation,
  bounds,
  setRegion,
  region,
  isMapSettingModalOpen,
}: any) => {
  const { modalDispatch } = useModal();

  const [openRegionModal, setOpenRegionModal] = useState(false);
  const [openSettingModal, setOpenSettingModal] = useState(false);

  const getLocation = async () => {
    if (!bounds.swLat || !bounds.swLng || !bounds.neLat || !bounds.neLng)
      return;
    if (!isLogin()) {
      return;
    }
    try {
      const res = await MapService.currentLocation(
        bounds.swLat,
        bounds.swLng,
        bounds.neLat,
        bounds.neLng,
      );
      setRegion({
        sido: res.data.sido ?? '',
        gugun: res.data.gugun ?? '',
        dong: res.data.emd ?? '',
      });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getLocation();
  }, [bounds]);

  return (
    <Container>
      <ButtonWrapper>
        <Button onClick={() => setOpenSettingModal(true)}>
          <img src="/assets/images/icon/map_setting.svg" alt="" />
        </Button>
        <Button onClick={getUserLocation}>
          <img src="/assets/images/icon/rocation.svg" alt="" />
        </Button>
      </ButtonWrapper>

      <LocationWrapper
        onClick={() => {
          if (!isLogin()) {
            modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
            return;
          }
          setOpenRegionModal(true);
        }}
      >
        <img src="/assets/images/icon/location_blue.svg" alt="" />
        <LocationBox>
          <div>{region?.gugun || '서초구'}</div>
          <img
            src="/assets/images/arrow/arrow-right-gray-alternative.svg"
            alt=""
          />
          <div>{region?.dong || '양재동'}</div>
        </LocationBox>
      </LocationWrapper>

      {openSettingModal && (
        <MapSettingModal onClose={() => setOpenSettingModal(false)} />
      )}

      {openRegionModal && (
        <RegionModal onClose={() => setOpenRegionModal(false)} />
      )}
    </Container>
  );
};

export default MapFilter;

const Container = styled.div`
  /* width: 100%;
  height: 100%; */
  /* position: relative; */
  z-index: 2001;

  & > * {
    pointer-events: auto; /* 자식 요소는 클릭 가능 */
  }
`;

const LocationBox = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
`;

const LocationWrapper = styled.div`
  position: fixed;
  bottom: 78px;
  left: 50%;
  transform: translateX(-50%);

  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  box-shadow: 0px 2px 4px rgba(51, 53, 56, 0.08);
  border-radius: 9999px;
  border: 1px #e1e2e4 solid;
  background-color: #fff;
  padding: 8px 12px;

  color: #616161;
  font-size: 14px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
  box-shadow: 0px 0px 1px 0px #00000014;
  box-shadow: 0px 1px 4px 0px #00000014;
  box-shadow: 0px 2px 8px 0px #0000001f;

  max-width: calc(100% - 32px); /* 좌우 여백 */
  box-sizing: border-box; /* 패딩 포함 */
  width: fit-content;

  img {
    width: 20px;
    height: 20px;
  }
`;

const ButtonWrapper = styled.div`
  position: absolute;
  left: 16px;
  bottom: 78px;

  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;
`;

const Button = styled.button`
  outline: none;

  display: flex;
  padding: 8px;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
  background: #fff;
  box-shadow: 0 0 8px 0 rgba(51, 53, 56, 0.2);
`;
